import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const faqData = [
  {
    question: "How much can I borrow?",
    answer: "You can borrow up to KSh 5,000,000.",
  },
  {
    question: "Can I pay off my loan early?",
    answer: "Yes, early repayment is allowed without penalty.",
  },
  {
    question: "Do you offering refinancing ?",
    answer: "Yes, we offer refinancing options. Please contact support.",
  },
  {
    question: "When should I apply?",
    answer: "You can apply at any time once you meet the eligibility criteria.",
  },
];

const FaqAccordion = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleIndex = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="font-serif p-6">
      <h2 className="text-2xl font-semibold text-slate-700 mb-4">
        General Questions
      </h2>
      <div className="border-t">
        {faqData.map((item, index) => (
          <div key={index} className="border-b">
            <button
              className={`w-full text-left flex items-center justify-between px-4 py-4 focus:outline-none ${
                index === activeIndex ? "text-amber-500" : "text-slate-800"
              }`}
              onClick={() => toggleIndex(index)}
            >
              <span className="text-sm font-medium">{item.question}</span>
              {index === activeIndex ? (
                <Minus className="w-4 h-4" />
              ) : (
                <Plus className="w-4 h-4" />
              )}
            </button>
            {index === activeIndex && (
              <div className="px-4 pb-4 text-slate-500 text-sm">
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqAccordion;
